module.exports = __webpack_public_path__ + "static/media/authority_mgmt_icon.466ac0a0.png";